import { DispatchedReportItem, ExportedReportItem } from '@futrli-sdk/report_scheduling';

export type ExportedPdfListItem =
  | ({ type: 'exported' } & ExportedReportItem)
  | ({ type: 'dispatched' } & DispatchedReportItem);

export const combineExportedPdfItems = (
  exportedReports: ExportedReportItem[],
  dispatchedReports: DispatchedReportItem[]
): ExportedPdfListItem[] => [
  ...exportedReports.map(item => ({ type: 'exported' as const, ...item })),
  ...dispatchedReports.map(item => ({ type: 'dispatched' as const, ...item }))
];
